import APP_ENV from '../../configs/appEnv';
import { getIdToken, oktaSignout, renewToken } from '../../utils/oktaAuth';
import Request from '../../utils/request';
import {
  applyErrorResponseHandler,
  applySuccessResponseHandler,
} from './responseHandler';

const ProtectedRequest = new Request({
  baseURL: APP_ENV.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
ProtectedRequest._client.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    const idToken = await getIdToken();
    config.headers['Authorization'] = `Bearer ${idToken.idToken}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
let refreshTokenResponsePromise: Promise<any> | null;
ProtectedRequest._client.interceptors.response.use(
  function (response) {
    return applySuccessResponseHandler(response);
  },
  async function (error) {
    const originalRequest = error.config;
    ///Handle Authentication error/////
    if (error?.response?.status === 401 && !originalRequest._retry) {
      ///Trying to refresh the request for one time
      if (!refreshTokenResponsePromise) {
        refreshTokenResponsePromise = renewToken();
      }
      try {
        const refreshTokenRes = await refreshTokenResponsePromise;

        if (refreshTokenRes?.idToken) {
          originalRequest._retry = true;

          refreshTokenResponsePromise = null;
          ProtectedRequest.client.defaults.headers['Authorization'] =
            `Bearer ${refreshTokenRes.idToken}`;
          originalRequest.headers.Authorization = `Bearer ${refreshTokenRes.idToken}`;
          return await ProtectedRequest.client.request(originalRequest);
        }
      } catch (refreshError) {
        console.error('API REFRESH ERROR 💥', refreshError);
        await oktaSignout();
        throw refreshError;
      }
    }
    return Promise.reject(applyErrorResponseHandler(error));
  }
);

export default ProtectedRequest;
